import { render, staticRenderFns } from "./AddressHistory.vue?vue&type=template&id=f834408a"
import script from "./AddressHistory.vue?vue&type=script&lang=js"
export * from "./AddressHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports